export default {
    changeCollapse(state) {
        state.isCollapse = !state.isCollapse;
        try {
            sessionStorage.isCollapse = state.isCollapse;
            // eslint-disable-next-line no-empty
            } catch (e) {
        }
    },
    minCollapse(state) {
        state.isCollapse = true;
        try {
            sessionStorage.isCollapse = state.isCollapse;
            // eslint-disable-next-line no-empty
        } catch (e) {
        }
    },
    setLogin(state,token) {
        state.access_token = token.access_token;
        state.refresh_token = token.refresh_token;
        try {
            localStorage.setItem('access_token',token.access_token)
            localStorage.setItem('refresh_token',token.refresh_token)
            // eslint-disable-next-line no-empty
        } catch (e) {
        }
    },
    refreshToken(state,token){
        console.log(568)
        state.access_token = token;
        try {
            localStorage.setItem('access_token',token)
            // eslint-disable-next-line no-empty
        } catch (e) {
        }
    },
    setLogout(state){
        state.access_token='';
        state.refresh_token='';
        state.user_info={};
        state.userMenus=[];
        state.userRoles=[];
        state.userPermissions=[];
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user_info');
        localStorage.removeItem('user_type');
        localStorage.removeItem('user_menus');
        localStorage.removeItem('user_roles');
        localStorage.removeItem('user_permissions');
    },
    setUserInfo(state,info){
        state.user_info=info;
        localStorage.setItem('user_info',JSON.stringify(info))
    },
    setIntNo(state,int_no){
        state.int_no=int_no;
        // localStorage.setItem('user_info',JSON.stringify(info))
        sessionStorage.setItem('int_no',int_no)
    },
    setUserMenus(state, menus){
        state.userMenus = menus;
        localStorage.setItem('user_menus', JSON.stringify(menus))
    },
    setUserRoles(state, roles){
        state.userRoles = roles;
        localStorage.setItem('user_roles', JSON.stringify(roles))
    },
    setUserPermissions(state, permissions){
        state.userPermissions = permissions;
        localStorage.setItem('user_permissions', JSON.stringify(permissions))
    }
}
